export enum BootstrapIconName {
    Shop = 'shop',
    PieChart = 'pie-chart',
    LayoutTextSidebarReverse = 'layout-text-sidebar-reverse',
    FileText = 'file-text',
    Plug = 'plug',
    ArrowRightCircle = 'arrow-right-circle',
    ArrowDownRightCircle = 'arrow-down-right-circle',
    ArrowUpRightCircle = 'arrow-up-right-circle',
    Toggles2 = 'toggles2',
    Wallet2 = 'wallet2',
    ChevronDown = 'chevron-down',
    ChevronUp = 'chevron-up',
    ChevronLeft = 'chevron-left',
    ChevronRight = 'chevron-right',
    BoxArrowUpRight = 'box-arrow-up-right',
    X = 'x',
    Person = 'person',
    List = 'list',
    ArrowRightSquare = 'arrow-right-square',
    ArrowRight = 'arrow-right',
    Pencil = 'pencil',
    Send = 'send',
    Paperclip = 'paperclip',
    QuestionCircle = 'question-circle',
}
